import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CONFIG_PARAMS, DEFAULT_GRID_CONFIG } from '../constants';
import type { PulseGridConfig } from '../types';

/**
 * Reads grid configuration from URL search params, falling back to defaults.
 * This allows per-TV customization via URL (e.g. /pulse?cols=7&gap=0&rank=10).
 */
export function useGridConfig(): PulseGridConfig {
  const [params] = useSearchParams();

  return useMemo((): PulseGridConfig => {
    const int = (key: string, fallback: number) => {
      const v = params.get(key);
      if (v == null) return fallback;
      const n = parseInt(v, 10);
      return Number.isFinite(n) && n >= 0 ? n : fallback;
    };

    return {
      columns: int(CONFIG_PARAMS.columns, DEFAULT_GRID_CONFIG.columns),
      gap: int(CONFIG_PARAMS.gap, DEFAULT_GRID_CONFIG.gap),
      rankIntervalSec: int(CONFIG_PARAMS.rankInterval, DEFAULT_GRID_CONFIG.rankIntervalSec),
      maxAgeSec: int(CONFIG_PARAMS.maxAge, DEFAULT_GRID_CONFIG.maxAgeSec),
      transitionDurationMs: int(CONFIG_PARAMS.transition, DEFAULT_GRID_CONFIG.transitionDurationMs),
    };
  }, [params]);
}
